export default __webpack_public_path__ + "static/media/lucene.f537e4a7.svg";